<template>
  <div>
    <el-container>
      <el-header class="fu">
        <!-- 首页黑 -->
        <el-row
          v-if="top == 1"
          type="flex"
          justify="start"
          class="hidden-xs-only"
        >
          <el-col :span="10">
            <div class="bgc h-70 width-100 d-flex-items-center d-flex-center">
              <img
                :src="info.base_info.logo_url"
                class="w-250 h-50"
                @click="go('/index')"
              />
            </div>
          </el-col>
          <el-col :span="14">
            <div class="bgc h-70 width-100 c-white d-flex-items-center">
              <div class="width-90 ml-10 mr-10 d-flex-between">
                <div
                  v-for="(item, index) in tab"
                  :key="index"
                  @click="select(index, item.url)"
                  class="c-white"
                >
                  <div class="d-flex-items-center h-65">{{ item.name }}</div>
                  <div :class="nav == index ? 'bgc-white h-4' : ''"></div>
                </div>
                <div
                  v-if="$cache.getCache('userInfo') != undefined"
                  class="d-flex-row d-flex-items-center"
                >
                  <div
                    class="w-40 h-40 br-60 bgc-F4F4F4 d-flex-items-center d-flex-center"
                  >
                    <i
                      v-if="$cache.getCache('userInfo').avatar == undefined"
                      class="el-icon-user-solid c-E1E1E1 f-24"
                    ></i>
                    <img
                      v-else
                      :src="$cache.getCache('userInfo').avatar"
                      class="w-40 h-40 br-60"
                    />
                  </div>
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link c-white f-18 m-l-15">
                      {{ $cache.getCache("userInfo").mobile }}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">个人中心</el-dropdown-item>
                      <el-dropdown-item command="2">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-else>
                  <span class="m-r-15 lh-70" @click="go('/login')">登录</span>
                  |<span class="m-l-15" @click="go('/register')">注册</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 背景是白色的导航 -->
        <el-row
          v-else-if="top == 2"
          type="flex"
          justify="start"
          class="hidden-xs-only"
        >
          <el-col :span="10">
            <div
              class="bgc-white h-70 width-100 d-flex-items-center d-flex-center"
            >
              <img
                src="@/assets/image/index/logo-bai.png"
                class="w-250 h-50"
                @click="go('/index')"
              />
            </div>
          </el-col>
          <el-col :span="14">
            <div class="bgc-white h-70 width-100 c-00 d-flex-items-center">
              <div class="width-90 ml-10 mr-10 d-flex-between">
                <div
                  v-for="(item, index) in tab"
                  :key="index"
                  @click="select(index, item.url)"
                  class="c-00"
                >
                  <div class="d-flex-items-center h-65">{{ item.name }}</div>
                  <div :class="nav == index ? 'bgc-ea4638 h-4' : ''"></div>
                </div>
                <div
                  v-if="$cache.getCache('userInfo') != undefined"
                  class="d-flex-row d-flex-items-center"
                >
                  <div
                    class="w-40 h-40 br-60 bgc-F4F4F4 d-flex-items-center d-flex-center"
                  >
                    <i
                      v-if="$cache.getCache('userInfo').avatar == undefined"
                      class="el-icon-user-solid c-E1E1E1 f-24"
                    ></i>
                    <img
                      v-else
                      :src="$cache.getCache('userInfo').avatar"
                      class="w-40 h-40 br-60"
                    />
                  </div>
                  <el-dropdown @command="handleCommand">
                    <span class="el-dropdown-link c-00 f-18 m-l-15">
                      {{ $cache.getCache("userInfo").mobile }}
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="1">个人中心</el-dropdown-item>
                      <el-dropdown-item command="2">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div v-else>
                  <span class="m-r-15 lh-70" @click="go('/login')">登录</span>
                  |<span class="m-l-15" @click="go('/register')">注册</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 登录的导航 -->
        <el-row
          v-else-if="top == 3"
          type="flex"
          justify="start"
          class="hidden-xs-only"
        >
          <el-col :span="10">
            <div
              class="bgc-white h-70 width-100 d-flex-items-center d-flex-center"
            >
              <img
                src="@/assets/image/index/logo-bai.png"
                class="w-250 h-50"
                @click="go('/index')"
              />
            </div>
          </el-col>
          <el-col :span="14">
            <div class="bgc-white h-70 width-100 c-00 d-flex-items-center">
              <div class="width-90 ml-10 mr-10 d-flex-end">
                <div class="d-flex-row d-flex-items-center">
                  <div
                    class="w-40 h-40 br-60 bgc-F4F4F4 d-flex-items-center d-flex-center"
                  >
                    <i class="el-icon-user-solid c-E1E1E1 f-24"></i>
                  </div>
                  <span class="f-18 c-00 m-l-15">{{ name }}！</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 手机端 -->
        <el-row
          v-if="top != 4"
          type="flex"
          justify="start"
          class="hidden-sm-and-up"
        >
          <el-col :span="10">
            <div class="bgc h-70 width-100 d-flex-items-center">
              <img
                src="@/assets/image/index/logo.png"
                class="w-210 h-40 m-l-30"
                @click="go('/index')"
              />
            </div>
          </el-col>
          <el-col :span="14">
            <div
              class="bgc h-70 width-100 c-white d-flex-items-center d-flex-end"
            >
              <el-dropdown @command="go">
                <span class="el-dropdown-link">
                  <img
                    src="@/assets/image/index/caidan.png"
                    class="w-30 h-40 m-r-30"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="item.url"
                    @click="select(index, item.url)"
                    v-for="(item, index) in tab1"
                    :key="index"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <el-main style="height: 100vh; width: 100vw">
        <router-view />
        <!-- 黑色平常的-->
        <div v-if="bottom == 1">
          <el-row
            type="flex"
            justify="start"
            :class="backcolor ? 'bgc-white c-00' : 'bgc-bg c-white'"
            class="hidden-xs-only"
          >
            <el-col :span="24" class="h-340 d-flex-between p-100">
              <div class="width-50 p-l-200">
                <div class="m-b-80 width-100 d-flex-between">
                  <div
                    @click="go(item.url)"
                    v-for="(item, index) in listbotm"
                    :key="index"
                    :class="listbotm.length == index + 1 ? '' : 'b-r'"
                    class="f-18 p-r-15 p-l-15 d-flex-center width-100"
                  >
                    {{ item.name }}
                  </div>
                </div>
                <div class="f-18">客服热线</div>
                <div class="f-36 font-weight-bold m-t-10">
                  {{ info.base_info.contact_tel }}
                </div>
              </div>
              <div class="d-flex-row">
                <div class="">
                  <img
                    src="@/assets/image/index/er.png"
                    class="w-123 h-123 m-10"
                  />
                  <div class="m-t-10 f-18 d-flex-center">app下载</div>
                </div>
                <div class="">
                  <img
                    src="@/assets/image/index/er.png"
                    class="w-123 h-123 m-10"
                  />
                  <div class="m-t-10 f-18 d-flex-center">关注公众号</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            v-if="bottom == 1"
            :class="backcolor ? 'bgc-white c-00' : 'bgc-bg c-white'"
            class="mtcx-box"
          >
            <div
              class="c-00 h-65 d-flex-items-center d-flex-center b-t c-99 f-18"
            >
              <a href="https://beian.miit.gov.cn">吉ICP备17006916号</a>
            </div>
          </el-row>
        </div>
        <!-- 登录的底 -->
        <el-row
          v-if="bottom == 2"
          type="flex"
          justify="start"
          class="bgc-white hidden-xs-only"
        >
          <el-col :span="24">
            <div class="c-00 h-340 d-flex-between p-100">
              <div class="width-50 p-l-200">
                <div class="m-b-80 width-100 d-flex-between">
                  <div
                    @click="go(item.url)"
                    v-for="(item, index) in listbotm"
                    :key="index"
                    :class="listbotm.length == index + 1 ? '' : 'b-r'"
                    class="f-18 p-r-15 p-l-15"
                  >
                    {{ item.name }}
                  </div>
                </div>
                <div class="f-18">联系我们：</div>
                <div class="f-36 font-weight-bold m-t-10">
                  {{ info.base_info.contact_tel }}
                </div>
              </div>
              <div class="d-flex-row">
                <div class="">
                  <img
                    src="@/assets/image/index/er.png"
                    class="w-123 h-123 m-10"
                  />
                  <div class="m-t-10 f-18 d-flex-center">app下载</div>
                </div>
                <div class="">
                  <img
                    src="@/assets/image/index/er.png"
                    class="w-123 h-123 m-10"
                  />
                  <div class="m-t-10 f-18 d-flex-center">关注公众号</div>
                </div>
              </div>
            </div>
            <div
              class="c-00 h-65 d-flex-items-center d-flex-center b-t c-99 f-18"
            >
              <!-- 吉ICP备17006916号-1 Copyright@2017 reserved -->
              <a href="https://beian.miit.gov.cn">吉ICP备17006916号</a>
            </div>
          </el-col>
        </el-row>

        <!-- 手机端 -->
        <el-row
          v-if="ibottom"
          type="flex"
          justify="start"
          :class="backcolor ? 'bgc-white c-00' : 'bgc-bg c-white'"
          class="hidden-sm-and-up"
        >
          <el-col :span="24" class="p-50 width-100">
            <div class="m-b-40 width-90 d-flex-wrap">
              <div
                @click="go(item.url)"
                v-for="(item, index) in listbotm"
                :key="index"
                :class="listbotm.length == index + 1 ? '' : 'b-r'"
                class="f-18 p-r-10 p-l-10 m-t-20"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="f-18 d-flex-center">客服热线</div>
            <div class="f-36 m-b-40 font-weight-bold m-t-10 d-flex-center">
              {{ info.base_info.contact_tel }}
            </div>
            <div class="d-flex-center">
              <div class="">
                <img
                  :src="info.base_info.down_app_code"
                  class="w-123 h-123 m-10"
                />
                <div class="m-t-10 f-18 d-flex-center">app下载</div>
              </div>
              <div class="">
                <img :src="info.base_info.wx_code" class="w-123 h-123 m-10" />
                <div class="m-t-10 f-18 d-flex-center">关注公众号</div>
              </div>
            </div>
            <div class="f-14 c-99 width-100 m-t-40 d-flex-center">
              <!-- 公司备案号信息公司备案号信息 -->
              <a href="https://beian.miit.gov.cn">吉ICP备17006916号</a>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
      // 电脑端的
      tab: [
        {
          name: "首页",
          url: "/index",
        },
        {
          name: "房源分布",
          url: "/housing",
        },
        {
          name: "新闻中心",
          url: "/journalism",
        },
        {
          name: "关于我们",
          url: "/about",
        },
        {
          name: "联系我们",
          url: "/contact",
        },
        // {
        // 	name: '入住须知',
        // 	url: "/check"
        // }, {
        // 	name: '服务中心',
        // 	url: "/service"
        // },
      ],
      // 手机端的
      tab1: [
        {
          name: "首页",
          url: "/index",
        },
        {
          name: "房源分布",
          url: "/housing",
        },
        {
          name: "新闻中心",
          url: "/journalism",
        },
        {
          name: "关于我们",
          url: "/about",
        },
        {
          name: "联系我们",
          url: "/contact",
        },
        {
          name: "个人中心",
          url: "/personal",
        },
        // {
        // 	name: '入住须知',
        // 	url: "/check"
        // }, {
        // 	name: '服务中心',
        // 	url: "/service"
        // },
        {
          name: "登录 | 注册",
          url: "/login",
        },
      ],
      nav: 0,
      listbotm: [
        {
          name: "首页",
          url: "/index",
        },
        {
          name: "房源分布",
          url: "/housing",
        },
        {
          name: "新闻中心",
          url: "/journalism",
        },
        {
          name: "关于我们",
          url: "/service",
        },
        {
          name: "联系我们",
          url: "/contact",
        },
        // {
        // 	name: '入住须知',
        // 	url: "/check"
        // },
      ],
      top: 1,
      bottom: 1,
      name: "",
      ibottom: true,
      backcolor: false,
      info: {
        base_info: {},
      },
    };
  },
  mounted() {
    this.getinfo();
    this.$router.push("/index");
  },
  watch: {
    $route(to, from) {
      // 控制底部的
      if (to.fullPath == "/housing") {
        // 不展示的
        this.bottom = 3;
        // 手机端 下面的
        this.ibottom = true;
      } else if (
        to.fullPath == "/login" ||
        to.fullPath == "/register" ||
        to.fullPath == "/forget"
      ) {
        // 登录和注册
        this.bottom = 2;
        // 手机端
        this.ibottom = false;
      } else {
        this.bottom = 1;
        // 手机端
        this.ibottom = true;
      }

      // 个人中心
      if (to.fullPath == "/personal") {
        this.backcolor = true;
        this.nav = -1;
      } else {
        this.backcolor = false;
      }

      // 新闻中心，联系我们
      if (to.fullPath == "/journalism" || to.fullPath == "/contact") {
        this.backcolor = true;
      } else {
        this.backcolor = false;
      }

      // 控制上方导航的
      if (to.fullPath == "/index") {
        // 背景透明黑
        this.top = 1;
      } else if (
        to.fullPath == "/login" ||
        to.fullPath == "/register" ||
        to.fullPath == "/forget"
      ) {
        // 登录和注册
        this.top = 3;
      } else {
        // 背景白色普通的头部
        this.top = 2;
      }

      if (to.fullPath == "/login") {
        // 登录和注册
        this.name = "欢迎登录";
      } else if (to.fullPath == "/register") {
        this.name = "欢迎注册";
      } else if (to.fullPath == "/forget") {
        this.name = "忘记密码";
      }

      // 控制上方图标的
      if (to.fullPath == "/index") {
        this.nav = 0;
      } else if (to.fullPath == "/housing") {
        this.nav = 1;
      } else if (to.fullPath == "/journalism") {
        this.nav = 2;
      } else if (to.fullPath == "/service") {
        this.nav = 3;
      } else if (to.fullPath == "/contact") {
        this.nav = 4;
      }
    },
  },
  methods: {
    async getinfo() {
      const res = await this.$service.get({
        url: "/api/web/v1/app_get_index",
      });
      if (res.code === 1) {
        this.info = res.info;
        window.localStorage.setItem(
          "contact_tel",
          res.info.base_info.contact_tel
        );
      }
    },
    handleCommand(command) {
      if (command === "1") {
        this.$router.push("/personal");
        return;
      }
      if (command === "2") {
        this.$cache.deleteCache("userInfo");
        this.$cache.deleteCache("token");
        this.$router.go(0);
        return;
      }
    },
    go(url) {
      this.$router.push(url);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    select(index, url) {
      this.nav = index;
      this.$router.push(url);
    },
  },
};
</script>

<style scoped>
.bgc-ea4638 {
  background: #ea4638;
}

.bgc {
  background: rgba(0, 0, 0, 0.26);
}

.fu {
  position: absolute;
  z-index: 99;
  width: 100%;
}

.el-header {
  padding: 0;
}
.mtcx-box {
  display: block;
}
@media (max-width: 767px) {
  .mtcx-box {
    display: none;
  }
}
</style>
<style>
.el-menu {
  background: rgba(0, 0, 0, 0.26) !important;
}

.el-card__body,
.el-main {
  padding: 0px !important;
}
</style>
